<template>
  <div id="app">

    <MiiaFwLoading v-if="$store.getters['miiaFwStore/isLoading']"></MiiaFwLoading>
    <router-view></router-view>
    <!--
    <div class="contents">
      <div class="header">
        <MiiaFwHeader></MiiaFwHeader>
      </div>
      <router-view></router-view>
    </div>
    -->
    <!--
    <div class="footer">
      <MiiaFwFooter></MiiaFwFooter>
    </div>
    -->
  </div>
</template>

<script>
import router from '@/router/index.js'
// import MiiaFwHeader from '@/components/common/header.vue'
// import MiiaFwFooter from '@/components/common/footer.vue'
import MiiaFwLoading from '@/components/miiafw/util/MiiaFwLoading.vue'
import MiiaFwCognitoMixin from '@/components/miiafw/mixin/MiiaFwCognitoMixin.vue'
import MiiaFwUserAttributesMixin from '@/components/miiafw/mixin/MiiaFwUserAttributesMixin.vue'
import SensitiveInfoMixin from '@/components/mixin/SensitiveInfoMixin.vue'

export default {
  name: 'App',
  // components: { MiiaFwHeader, MiiaFwFooter, MiiaFwLoading },
  components: { MiiaFwLoading },
  data () {
    return {
      view: '',
      routes: router.app._router.options.routes // メニュー表示用にRouterから取得
    }
  },
  mixins: [MiiaFwCognitoMixin, MiiaFwUserAttributesMixin, SensitiveInfoMixin],
  beforeMount () {
    this.$i18n.locale = this.$lang // 言語設定
    if (this.$authorization.mustAuth) {
      // 認証必須システム
      if (this.$store.getters['miiaFwStore/isAuthorized']) {
        // 認証済
      } else {
        // 未認証
        // トークン取得処理
        this.miiafwlibs_setLoadingView(true)
        this.getInfo()
        this.miiafwCognitolibs_isAuthenticated().then((result) => {
          // 未認証から認証中へ変化した場合と認証中にリフレッシュした場合は必ずisAuthorizedがfalse → trueに変化し、getInfo内の処理が実行される。
          // 認証中であった場合の処理中解除はgetInfo()処理内で実施
          // リフレッシュ後に認証済であった場合に実施する処理(リフレッシュなしで認証した場合は通らない。)
        }).catch(() => {
          if (this.$route.meta.requiresAuth && this.$router.currentRoute.path !== '/') {
            this.$router.push({ path: '/' }) // 先にトップ画面に戻さないと表示されてしまう。
          }
          this.miiafwlibs_setLoadingView(false) // 同期処理終了後に必ず実行
        })
      }
      // 未認証状態でも表示可能なメニュー項目を設定
      this.miiafwCognitolibs_updateMenu(this.routes.filter(item => item.meta.onMenu && !item.meta.requiresAuth))
    } else {
      // 認証不要システムの場合は未認証状態でも表示可能なメニュー項目を設定
      this.miiafwCognitolibs_updateMenu(this.routes.filter(item => item.meta.onMenu && !item.meta.requiresAuth))
    }
    // 現在の画面を設定
    this.view = this.$route.name
  },
  methods: {
    getInfo () {
      this.$store.watch(
        (state, getters) => {
          return state.miiaFwStore.cognitoAuth.isAuthorized
        },
        (newVal, oldVal) => {
          if (newVal === true) {
            // 未認証から認証中へ変化した場合と認証中にリフレッシュした場合
            this.miiafwUserAttributes_getAttributes().then((user) => {
              // 認証が必要なメニューも含めて表示
              this.miiafwCognitolibs_updateMenu(this.routes.filter((value) => {
                if (value.meta.hasOwnProperty('accessibleRoles') && Array.isArray(value.meta.accessibleRoles)) {
                  if (!user.hasOwnProperty('attribute') || !user.attribute.hasOwnProperty(this.$sysId)) {
                    return false
                  }
                  const userAttributes = user.attribute[this.$sysId]
                  if (userAttributes.hasOwnProperty('role')) {
                    return value.meta.accessibleRoles.indexOf(userAttributes.role) > -1 && value.meta.onMenu
                  } else {
                    return false
                  }
                } else {
                  return value.meta.onMenu
                }
              }))
              this.sensitiveInfo_get().then(() => {
              }).catch((error) => {
                this.miiafwlibs_alert(error.message)
              }).then((result) => {
                this.miiafwlibs_setLoadingView(false)
              })
              this.miiafwlibs_setLoadingView(false)
            }).catch((error) => {
              this.miiafwlibs_alert(error.message)
              this.miiafwlibs_setLoadingView(false)
            })
          } else {
            // 未認証状態でも表示可能なメニュー項目を設定
            this.miiafwCognitolibs_updateMenu(this.routes.filter(item => item.meta.onMenu && !item.meta.requiresAuth))
          }
        }
      )
    }
  }
}
</script>

<style>
html {
  height: 100%;
}
body {
  height: 100%;
  margin: 0;
  /* background-color: honeydew; */
  background-color: white;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* [MiiaFW] 以下は、フッダ領域確保のための記述 */
  min-height: 100%;
  position: relative;
  height: auto !important;
  height: 100%;
  width: 100%;
}
.contents {
  padding-bottom: 80px; /* [MiiaFW] フッダ領域分を確保 */
}
.footer {
  display: block;
  position: absolute;
  bottom: 0%;
  width: 100%;  /* [MiiaFW]100%にすることで中央寄せになる。 */
  /* min-width: 600px; */
  text-align: center;
}
</style>
